export default "__VITE_ASSET__DQSXe6W$__"